module.exports = __webpack_public_path__ + "static/img/icon_search_close.390cec7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_search_close.svg
// module id = jL9A
// module chunks = 10